import type { PublicSlotKey } from '@/apilib';
import type { WixDataApi } from './api';

export const WixDataApiKey: PublicSlotKey<WixDataApi> = {
  name: 'WixDataApi',
  public: true,
};
